// 封装初始化函数
function initializeAddToCartButton() {
    // 获取所有name="add"且为button的元素
    var addButtons = document.querySelectorAll('button[name="add"]');

    // 判断是否只有一个元素
    if (addButtons.length === 1) {
        // 获取唯一的元素
        var button = addButtons[0];

        // 获取元素的id
        var buttonId = button.id;

        // 获取id为add-to-cart的按钮
        var addToCartButton = document.getElementById('add-to-cart');
        if (addToCartButton) {
            // 添加点击事件监听器
            addToCartButton.addEventListener('click', function(event) {

                // 模拟点击buttonId的按钮
                button.click();
            });
        } else {
            console.log('Button with ID add-to-cart not found');
        }
    } else {
        // 处理元素数量不为1的情况
        console.log('Number of buttons found:', addButtons.length);
        // 在这里添加其他处理代码
    }
}

// 监听页面滚动事件
window.addEventListener('scroll', function() {
    // 获取当前滚动位置
    var scrollPosition = window.scrollY || window.pageYOffset;

    // 获取id为floating-bar的元素
    var floatingBar = document.getElementById('floating-bar');

    // 获取id为add-to-cart的按钮
    var addToCartButton = document.getElementById('add-to-cart');

    // 如果滚动位置大于等于800px，则显示浮动条内容；否则隐藏浮动条内容
    if (scrollPosition >= 800) {
        floatingBar.style.bottom = '0';
        if (addToCartButton) {
            addToCartButton.style.display = 'block';
        }
    } else {
        floatingBar.style.bottom = '-100px';
        if (addToCartButton) {
            addToCartButton.style.display = 'none';
        }
    }
});

// 等待DOM完全加载后执行初始化函数和监听滚动事件
document.addEventListener('DOMContentLoaded', function() {
    initializeAddToCartButton();

    // 初始隐藏浮动条内容
    var floatingBar = document.getElementById('floating-bar');
    floatingBar.style.bottom = '-100px';
});

